/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PerformanceBreakdown } from "./PerformanceBreakdown";
import {
  PerformanceBreakdownFromJSON,
  PerformanceBreakdownFromJSONTyped,
  PerformanceBreakdownToJSON,
  PerformanceBreakdownToJSONTyped,
} from "./PerformanceBreakdown";

/**
 * What the carrier actually hauls for us, as distributions rather than
 * averages — one 20,000 lb outlier drags a mean somewhere no shipment
 * really is. Aimed squarely at their pricing team.
 *
 * @export
 * @interface PerformanceFreightProfile
 */
export interface PerformanceFreightProfile {
  /**
   *
   * @type {number}
   * @memberof PerformanceFreightProfile
   */
  shipments: number;
  /**
   *
   * @type {Array<PerformanceBreakdown>}
   * @memberof PerformanceFreightProfile
   */
  weightBands: Array<PerformanceBreakdown>;
  /**
   *
   * @type {Array<PerformanceBreakdown>}
   * @memberof PerformanceFreightProfile
   */
  densityBands: Array<PerformanceBreakdown>;
  /**
   *
   * @type {Array<PerformanceBreakdown>}
   * @memberof PerformanceFreightProfile
   */
  linearFeetBands: Array<PerformanceBreakdown>;
  /**
   *
   * @type {Array<PerformanceBreakdown>}
   * @memberof PerformanceFreightProfile
   */
  handlingUnitBands: Array<PerformanceBreakdown>;
  /**
   *
   * @type {Array<PerformanceBreakdown>}
   * @memberof PerformanceFreightProfile
   */
  deliveryRegions: Array<PerformanceBreakdown>;
  /**
   *
   * @type {Array<PerformanceBreakdown>}
   * @memberof PerformanceFreightProfile
   */
  serviceMix: Array<PerformanceBreakdown>;
}

/**
 * Check if a given object implements the PerformanceFreightProfile interface.
 */
export function instanceOfPerformanceFreightProfile(
  value: object,
): value is PerformanceFreightProfile {
  if (!("shipments" in value) || value["shipments"] === undefined) return false;
  if (!("weightBands" in value) || value["weightBands"] === undefined)
    return false;
  if (!("densityBands" in value) || value["densityBands"] === undefined)
    return false;
  if (!("linearFeetBands" in value) || value["linearFeetBands"] === undefined)
    return false;
  if (
    !("handlingUnitBands" in value) ||
    value["handlingUnitBands"] === undefined
  )
    return false;
  if (!("deliveryRegions" in value) || value["deliveryRegions"] === undefined)
    return false;
  if (!("serviceMix" in value) || value["serviceMix"] === undefined)
    return false;
  return true;
}

export function PerformanceFreightProfileFromJSON(
  json: any,
): PerformanceFreightProfile {
  return PerformanceFreightProfileFromJSONTyped(json, false);
}

export function PerformanceFreightProfileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceFreightProfile {
  if (json == null) {
    return json;
  }
  return {
    shipments: json["shipments"],
    weightBands: (json["weightBands"] as Array<any>).map(
      PerformanceBreakdownFromJSON,
    ),
    densityBands: (json["densityBands"] as Array<any>).map(
      PerformanceBreakdownFromJSON,
    ),
    linearFeetBands: (json["linearFeetBands"] as Array<any>).map(
      PerformanceBreakdownFromJSON,
    ),
    handlingUnitBands: (json["handlingUnitBands"] as Array<any>).map(
      PerformanceBreakdownFromJSON,
    ),
    deliveryRegions: (json["deliveryRegions"] as Array<any>).map(
      PerformanceBreakdownFromJSON,
    ),
    serviceMix: (json["serviceMix"] as Array<any>).map(
      PerformanceBreakdownFromJSON,
    ),
  };
}

export function PerformanceFreightProfileToJSON(
  json: any,
): PerformanceFreightProfile {
  return PerformanceFreightProfileToJSONTyped(json, false);
}

export function PerformanceFreightProfileToJSONTyped(
  value?: PerformanceFreightProfile | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipments: value["shipments"],
    weightBands: (value["weightBands"] as Array<any>).map(
      PerformanceBreakdownToJSON,
    ),
    densityBands: (value["densityBands"] as Array<any>).map(
      PerformanceBreakdownToJSON,
    ),
    linearFeetBands: (value["linearFeetBands"] as Array<any>).map(
      PerformanceBreakdownToJSON,
    ),
    handlingUnitBands: (value["handlingUnitBands"] as Array<any>).map(
      PerformanceBreakdownToJSON,
    ),
    deliveryRegions: (value["deliveryRegions"] as Array<any>).map(
      PerformanceBreakdownToJSON,
    ),
    serviceMix: (value["serviceMix"] as Array<any>).map(
      PerformanceBreakdownToJSON,
    ),
  };
}
